/**
 * This file demonstrates how to select Courier New Script.
 *
 * Some useful links for working with themes can be found at:
 * https://themes.material-ui.com/
 * https://material-ui.com/customization/default-theme/ //Will show all the properties you can edit
 * https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=c24f00&secondary.color=214563 //great for color selecting
 */


import { ThemeOptions } from '@material-ui/core';
import { AlmeTheme, defaultTheme } from '../../../models/AlmeTheme';


const fontFamily = {
    fontFamily: 'Courier New',
    letterSpacing: 'unset',
};

const typography = {
    subtitle1: {
        ...defaultTheme.typography.subtitle1,
        ...fontFamily,
        fontWeight: 'bold',
    },
    subtitle2: {
        ...defaultTheme.typography.subtitle2,
        ...fontFamily,
    },
    caption: {
        ...defaultTheme.typography.caption,
        ...fontFamily,
    },
    body1: {
        ...defaultTheme.typography.body1,
        ...fontFamily,
    },
    body2: {
        ...defaultTheme.typography.body2,
        ...fontFamily,
    },
    button: {
        ...defaultTheme.typography.button,
        textTransform: 'none',
    },
};

const lightModeTheme = { typography } as ThemeOptions;



export const appThemeMain = {
    lightTheme: lightModeTheme,
    darkTheme: {},
} as AlmeTheme;
